module.exports = __webpack_public_path__ + "75ba0e943aecfae3952a06a031dbae7e.svg";